import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-scala-architecture',
  templateUrl: './scala-architecture.component.html',
  styleUrls: ['./scala-architecture.component.sass']
})
export class ScalaArchitectureComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
